/** Date-only strings are calendar days, not UTC instants. */
export const toCalendarDate = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime())
      ? null
      : new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value));
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatTimesheetRangeLabel = (from, to) => {
  const start = from instanceof Date ? from : toCalendarDate(from);
  const end = to instanceof Date ? to : toCalendarDate(to);
  if (!start || !end) return "Select date range";
  const opts = { day: "numeric", month: "short" };
  const fromStr = start.toLocaleDateString("en-GB", opts);
  const toStr = end.toLocaleDateString("en-GB", {
    ...opts,
    year: "numeric",
  });
  return `${fromStr} – ${toStr}`;
};
